import React from 'react';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../../../../../components/with-label/WithLabel';
import MultiselectDropdownNew from '../../../../../../../components/multiselect-dropdown/MultiselectDropdownNew';
import SelectedOptionsList from '../../../../../selected-options-list/SelectedOptionsList';
import useH2HConceptsOptions from '../../hooks/useH2HConceptsOptions';

import scss from './ConceptH2HSelect.module.scss';

function ConceptH2HSelect({ selectedH2HConcepts, onChangeH2HConcepts, isLoading }) {
  const { t } = useTranslation('resonance');

  const h2hConceptsOptions = useH2HConceptsOptions();

  const handleSelectH2HConcept = (concepts) => {
    onChangeH2HConcepts(concepts);
  };

  const handleRemoveH2HConcept = (conceptValue) => {
    const filteredConcepts = selectedH2HConcepts.filter((selectedConcept) => selectedConcept.value !== conceptValue);
    onChangeH2HConcepts(filteredConcepts);
  };

  return (
    <div className={scss.wrapper}>
      <WithLabel label={`${t('headToHead')}:`} variant={LABEL_STYLES.CUSTOM} isBold extraClassName={scss.selectWrapper}>
        <MultiselectDropdownNew
          value={selectedH2HConcepts}
          options={h2hConceptsOptions}
          onChange={handleSelectH2HConcept}
          disableNewOptions
          disableSelectedOptionsRender
          isLoading={isLoading}
        />

        <SelectedOptionsList selectedOptions={selectedH2HConcepts} onRemoveOption={handleRemoveH2HConcept} />
      </WithLabel>
    </div>
  );
}

export default ConceptH2HSelect;
